import { Entity } from '@backstage/catalog-model';
import {
  EntityAutocompletePicker,
  DefaultEntityFilters,
  EntityFilter,
} from '@backstage/plugin-catalog-react';

// ── Filter class ─────────────────────────────────────────────────────────────

export class EntitySystemFilter implements EntityFilter {
  constructor(readonly values: string[]) {}

  filterEntity(entity: Entity): boolean {
    if (!this.values.length) return true;
    const system = (entity as any).spec?.system as string | undefined;
    return system !== null && system !== undefined && this.values.includes(system);
  }

  getCatalogFilters(): Record<string, string | string[]> {
    return { 'spec.system': this.values };
  }

  toQueryValue(): string[] {
    return this.values;
  }
}

// ── Extended filter bag ───────────────────────────────────────────────────────

export interface CustomCatalogFilters extends DefaultEntityFilters {
  system?: EntitySystemFilter;
  // Set by the TechDocs explorer's `TechDocsPicker` (documented entities only).
  techdocs?: EntityFilter;
}

// ── Picker component ──────────────────────────────────────────────────────────

export function EntitySystemPicker(props: {
  filtersForAvailableValues?: Array<keyof CustomCatalogFilters>;
}) {
  const { filtersForAvailableValues = ['kind'] } = props;
  return (
    <EntityAutocompletePicker<CustomCatalogFilters, 'system'>
      label="System"
      name="system"
      path="spec.system"
      Filter={EntitySystemFilter}
      filtersForAvailableValues={filtersForAvailableValues}
    />
  );
}

